"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignRequestState = void 0;
var SignRequestState;
(function (SignRequestState) {
    SignRequestState["NEW"] = "NEW";
    SignRequestState["SIGNED"] = "SIGNED";
    SignRequestState["CANCELED"] = "CANCELED";
    SignRequestState["ERROR"] = "ERROR";
})(SignRequestState = exports.SignRequestState || (exports.SignRequestState = {}));
//# sourceMappingURL=signing-types.js.map